export default "__VITE_ASSET__mT9ANXOJ__"